/**
 * wpk
 */
import axios from 'axios';
export const wpkReport = async (log: any) => {
  try {
    // @ts-ignore
    const { __itrace = {} } = window || {};
    if (__itrace && __itrace.bid === 'planck-encrypt-decrypt') {
      // @ts-ignore
      window.__itrace.report(log);
    } else {
      axios('https://vts.quark.cn/blm/itrace-proxy-590/proxy?uc_param_str=ntnwvepffrbiprsvchutosstxs', {
        method: 'POST',
        data: JSON.stringify({
          list: [
            {
              wpk: {
                bid: 'planck-encrypt-decrypt',
              },
              log: {
                w_url: location.href,
                ...log,
              },
            },
          ],
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(() => {})
        .catch(() => {});
    }
  } catch (e) {
    console.log('[wpk err]', log);
  }
};
/**
 * c1: chid
 * c2:
 */
export const serverWpkReport = (msg: string, log: any = {}) => {
  setTimeout(() => {
    wpkReport({
      category: 100,
      msg,
      ...log,
    }).catch(() => {});
  }, 1000);
};

export const nativeWpkReport = (msg: string, log: any = {}) => {
  setTimeout(() => {
    wpkReport({
      category: 101,
      msg,
      ...log,
    }).catch(() => {});
  }, 1000);
};

export const browserWpkReport = (msg: string, log: any = {}) => {
  setTimeout(() => {
    wpkReport({
      category: 102,
      msg,
      ...log,
    }).catch(() => {});
  }, 1000);
};
